exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-container[data-v-7db55c4c]{width:100%;min-height:400px}", ""]);

// exports
